import { Reveal, MaskedLines, Eyebrow } from "./primitives";
import { LOGO_MARK } from "../lib/site";

export const PageHero = ({ eyebrow, titleLines, description, testid }) => (
    <section
        data-testid={testid}
        className="grain relative overflow-hidden bg-[#04150D] pb-20 pt-40 sm:pb-24 sm:pt-48"
    >
        <div
            aria-hidden="true"
            className="absolute inset-0 bg-[radial-gradient(60%_60%_at_75%_10%,rgba(194,161,96,0.10),transparent_65%),radial-gradient(50%_50%_at_10%_90%,rgba(39,78,58,0.35),transparent_70%)]"
        />
        <img
            src={LOGO_MARK}
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute -right-24 top-1/2 w-[480px] max-w-none -translate-y-1/2 opacity-[0.06]"
        />
        <div className="relative z-[2] mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
            <Reveal>
                <Eyebrow dark>{eyebrow}</Eyebrow>
            </Reveal>
            <MaskedLines
                lines={titleLines}
                delay={0.15}
                className="font-display mt-5 max-w-4xl text-4xl font-medium leading-[1.08] tracking-tight text-[#FDFBF7] sm:text-5xl lg:text-6xl"
            />
            {description && (
                <Reveal delay={0.55}>
                    <p className="mt-7 max-w-2xl text-base leading-relaxed text-[#FDFBF7]/70 md:text-lg">
                        {description}
                    </p>
                </Reveal>
            )}
        </div>
    </section>
);
